module.exports = __webpack_public_path__ + "img/content7.4f03ca67.png";